import { api } from '../config'

export const SUPPORT_URL = {
  getSupports: `${api.withAPI}user/api/v1/admin/support`,
  getSupport: `${api.withAPI}user/api/v1/admin/support`,
  deleteSupport: `${api.withAPI}user/api/v1/admin/support`,
  getReviews: `${api.withAPI}service/api/v1/admin/review`,
  getReview: `${api.withAPI}service/api/v1/admin/review`,
}
